import { GamePhase } from '@susdle/shared';

/** Reveal-arc phases where the float is suppressed outright — the locked
 *  brief keeps voice presence off the RevealPlate surfaces. Mirrors MockApp's
 *  speakingAllowed (which excludes non-discussion cycler stages). */
const REVEAL_ARC: ReadonlySet<GamePhase> = new Set([
  GamePhase.RoleReveal,
  GamePhase.GhostGuessing,
  GamePhase.GuessReveal,
]);

/**
 * Whether App should hand SpeakingProvider the live set this render. Mirrors MockApp's
 * gating: no reveal arc, no float while a phase cinematic runs (the meeting
 * page-turn / clue-giving entry cascade / game-end close-burn — same
 * suppression windows as the entry beats; during the GameEnd cinematic the
 * frozen prior-phase reveal cast rides a 3D-folding leaf, and voiceFloat.ts
 * forbids floats on 3D-rotated card faces). Suppression empties the
 * provider's set rather than unmounting it (the wrap must stay structurally
 * stable — see App.tsx); airborne tiles glide home on the release spring.
 */
export function isSpeakingAllowed(args: {
  phase: GamePhase;
  transitioning: boolean;
  cluegivingTransitioning: boolean;
  gameEndTransitioning: boolean;
}): boolean {
  if (REVEAL_ARC.has(args.phase)) return false;
  return !args.transitioning && !args.cluegivingTransitioning && !args.gameEndTransitioning;
}
